module.exports = __webpack_public_path__ + "static/media/1POLICY12.2441cde9.jpg";